import { TabsContent } from '@/components/common/tabs'
import type { TransactionsContext } from '@/queries/transactionsContext.query'
import type { StepData } from '@/types/transactionsContext'
import type { Vault } from '@/types/vault'
import { formatTokenValue } from '@vaultsfyi/common/utils'
import type { Address } from 'viem'
import { TxSteps } from '../sidePanel/txSteps'

interface Props {
  account: Address | undefined
  stepData: StepData
  onSubmit: () => void
  isSubmitLoading: boolean
  vault: Vault
  claimableRewards: NonNullable<NonNullable<TransactionsContext>['rewards']>['claimable']
  currentStep: number
}

export function ClaimRewardsTab({
  account,
  stepData,
  onSubmit,
  isSubmitLoading,
  vault,
  claimableRewards,
  currentStep,
}: Props) {
  const reward = claimableRewards[0]

  return (
    <form onSubmit={onSubmit}>
      <TabsContent value={stepData.name} className="mt-3 flex flex-col gap-3 md:mt-4 md:gap-4">
        <p className="text-xs">
          Available to claim:{' '}
          {formatTokenValue({ value: reward.amount, decimals: reward.asset.decimals }, { maximumFractionDigits: 6 })}{' '}
          {reward.asset.symbol}
        </p>
        <TxSteps
          account={account}
          stepData={stepData}
          activeStep={currentStep}
          loading={isSubmitLoading}
          label="Claim rewards"
          network={vault.network.name}
        />
      </TabsContent>
    </form>
  )
}
